import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=c838ef26&lang=pug&"
import script from "./Tutorial.vue?vue&type=script&lang=js&"
export * from "./Tutorial.vue?vue&type=script&lang=js&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c838ef26')) {
      api.createRecord('c838ef26', component.options)
    } else {
      api.reload('c838ef26', component.options)
    }
    module.hot.accept("./Tutorial.vue?vue&type=template&id=c838ef26&lang=pug&", function () {
      api.rerender('c838ef26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/components/Tutorial.vue"
export default component.exports